import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ToggleFillAction extends AbstractProvidedClass {
    newState;

    constructor(provider, appearance, fillColor, useFill) {
        super(provider);

        this.appearance = appearance;
        this.fillColor = fillColor;
        this.newState = useFill;
    }

    finish() {
        this.appearance.fillColor = this.newState ? this.p.color(this.fillColor) : null;
        this.appearance.parent.row.updateImg();
        this.actions.finish();
    }

    undo() {
        this.appearance.fillColor = !this.newState ? this.p.color(this.fillColor) : null;
        this.appearance.parent.row.updateImg();
    }

    redo() {
        this.appearance.fillColor = this.newState ? this.p.color(this.fillColor) : null;
        this.appearance.parent.row.updateImg();
    }
}
